import { useEffect, useMemo, useState } from "react";

function formatTimeLeft(secondsLeft) {
  const s = Math.max(0, Math.floor(secondsLeft || 0));
  const hours = Math.floor(s / 3600);
  const minutes = Math.floor((s % 3600) / 60);

  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m`;
  return `0m`;
}

export function useCountdown(expiresAtIso) {
  const targetMs = useMemo(() => {
    if (!expiresAtIso) return null;
    const t = Date.parse(expiresAtIso);
    return Number.isFinite(t) ? t : null;
  }, [expiresAtIso]);

  const [secondsLeft, setSecondsLeft] = useState(() => {
    if (!targetMs) return null;
    return Math.max(0, Math.floor((targetMs - Date.now()) / 1000));
  });

  useEffect(() => {
    // reset state if no timer
    if (!targetMs) {
      setSecondsLeft(null);
      return;
    }

    const update = () => {
      setSecondsLeft(Math.max(0, Math.floor((targetMs - Date.now()) / 1000)));
    };

    update(); // immediate update

    const id = setInterval(update, 60000);
    return () => clearInterval(id);
  }, [targetMs]);

  return {
    secondsLeft,
    label: secondsLeft !== null ? formatTimeLeft(secondsLeft) : "",
    isExpired: secondsLeft !== null && secondsLeft <= 0,
  };
}
